import { render, staticRenderFns } from "./LogEmails.vue?vue&type=template&id=5620f870&"
import script from "./LogEmails.vue?vue&type=script&lang=js&"
export * from "./LogEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports